import { Component, Input, OnInit } from '@angular/core';
import { StrainSaveMeasurement } from '../../models/save-measurement-models/strain-save.measurement';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-strain-report-overview',
  templateUrl: './strain-report-overview.component.html',
  styleUrls: ['./strain-report-overview.component.scss']
})
export class StrainReportOverviewComponent implements OnInit {
  @Input() measurement: StrainSaveMeasurement;

  columns = [];

  constructor(private sanitizer: DomSanitizer, private translate: TranslateService) { }

  ngOnInit() {
    this.columns = [
      {
        id: 0,
        value: "name"
      },
      {
        id: 1,
        value: "unit"
      },
      {
        id: 2,
        value: "min"
      },
      {
        id: 3,
        value: "max"
      },
    ]
  }

  get canDisplayDetails() {
    return this.measurement && this.measurement.details && this.measurement.gageMounting;
  }

  get canDisplayImages() {
    return this.measurement && this.measurement.images;
  }

  get canDisplayMeasurements() {
    return this.measurement && this.measurement.gageCharts;
  }

  get conditions() {
    return this.measurement && this.measurement.details ?
      this.translate.instant('admin.strain.tickets.reports.modal.step8.sections.details.conditions', {
        temperature: this.measurement.details.temperature, humidity: this.measurement.details.humidity
      }) : 'N/A';
  }

  getGageImageUrl(image, back = false) {
    return this.sanitizer.bypassSecurityTrustUrl(back ? image.backSideImage.url : image.frontSideImage.url);
  }

  getChartImageUrl(image: any) {
    if (image.url) {
      return this.sanitizer.bypassSecurityTrustUrl(image.url);
    }

    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(image as File));
  }
}
